import { yup } from "@utils/validation/validation";

export const ScheduledReportsValidationSchema = yup.object().shape({
  recipients: yup.array().of(yup.string().email()),
});
